import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import * as StatisticsActions from './statistics.action';
import { StatisticsService } from '../../services/statistics.service';
import { HttpErrorHandlerService } from '../../../services/http-error-handler.service';

@Injectable()
export class StatistcsEffect {
  constructor(
    private actions$: Actions,
    private statisticsService: StatisticsService,
    private httpErrorHandlerService: HttpErrorHandlerService
  ) { }

  loadSaleFullViewingLog$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StatisticsActions.GetSaleFullViewingLog),
      mergeMap((model) => {
        return this.statisticsService.getFullViewingLog(model.saleUID, model.uid, model.saleMemberId, model.typo, model.filter).pipe(
          map((saleFullViewingLogStatistcs) => StatisticsActions.GetSaleFullViewingLogSuccess({ saleFullViewingLogStatistcs })),
          catchError((err) => {
            this.httpErrorHandlerService.ShowErrorMessage(err)
            return of(StatisticsActions.GetSaleFullViewingLogFailure({ err }));
          })
        );
      })
    )
  );

  markAsArchive$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StatisticsActions.MarkAsArchive),
      mergeMap((model) => {
        return this.statisticsService.markAsArchive(model.activityLogId,model.active).pipe(
          map((response) => StatisticsActions.MarkAsArchiveSuccess({ response })),
          catchError((err) => {
            this.httpErrorHandlerService.ShowErrorMessage(err)
            return of(StatisticsActions.MarkAsArchiveFailure({ err }));
          })
        );
      })
    )
  );

  loadSaleViewSummary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StatisticsActions.GetSaleViewingSummary),
      mergeMap((model) => {
        return this.statisticsService.getSaleViewingSummary(model.saleUID, model.uid, model.saleMemberId, model.typo, model.filter).pipe(
          map((saleViewingSummary) => StatisticsActions.GetSaleViewingSummarySuccess({ saleViewingSummary })),
          catchError((err) => {
            this.httpErrorHandlerService.ShowErrorMessage(err)
            return of(StatisticsActions.GetSaleViewingSummaryFailure({ err }));
          })
        );
      })
    )
  );

  getConsignorSales$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StatisticsActions.getConsignorSales),
      mergeMap((model) =>
        this.statisticsService.getConsignorSales(model.saleUID, model.consignorUID).pipe(
          map((sales) => StatisticsActions.getConsignorSalesSuccess({ sales })),
          catchError((error) => {
            this.httpErrorHandlerService.ShowErrorMessage(error)
            return of(StatisticsActions.getConsignorSalesFailure({ error }))
          })
        )
      )
    )
  );
}
